import { AxiosInstance } from "axios";
import { ApiService } from "../model/Api.model";
import { IPremise, PremisseByTypeEnum } from "../interface/Premises/Premises";

enum PremiseServiceEnum {
  getAll = "/listByType"
}

export default class PremiseService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/partner/pricing/premisse");
  }

  public getAll = async (AdministratorCnpj: string, Origin: string, premiseType: PremisseByTypeEnum): Promise<IPremise> => await this.GET(`${PremiseServiceEnum.getAll}?AdministratorCnpj=${AdministratorCnpj}&Origin=${Origin}&PremisseByTypeEnum=${premiseType}`);

}


// WEBPACK FOOTER //
// ./src/services/api/Premise.service.ts